var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "form",
            {
              attrs: { id: "importTasksform", enctype: "multipart/form-data" }
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-md-6 form-group" }, [
                  _c("label", [
                    _vm._v(" Select Excel File to Import Sales Data:")
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      ref: "fileglexportdata",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        name: "excl_file",
                        accept: ".xlsx,.xls",
                        id: "glexportupload"
                      },
                      on: {
                        change: function($event) {
                          return _vm.handleFilesUploadCall()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.importData }
                      },
                      [_vm._v("Import")]
                    )
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", [void 0], 2)
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Sales Import")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "btn btn-secondary mb-0",
        attrs: { for: "glexportupload" }
      },
      [
        _c("i", {
          staticClass: "fa fa-upload mr-3",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v("Upload File ...")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fe297e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe297e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales/sales.vue
// module id = null
// module chunks = 